// This is currently a placeholder for a more complete logging solution

class Logger {
    static log(...args) {
        console.log(...args);
    }

    static debug(...args) {
        console.debug(...args);
    }

    static info(...args) {
        console.info(...args);
    }

    static warn(...args) {
        console.warn(...args);
    }

    static error(...args) {
        console.error(...args);
    }
}

export { Logger as default, Logger as log };
